import {useTranslation} from "next-i18next";

export const useStatus = () => {
  const {t} = useTranslation('form')

  return {
    getErrorReason: (error: any) => {
      if (error != null && error.data) {
        if (typeof error.data.message === "string") {
          return t("error." + error.data.message)
        }
        try {
          return t("error." + JSON.parse(error.data).message)
        } catch (e) {

        }
      }
      return t("error.internal_server_error")
    },
  }
}
